import React from "react";

import echarts from "echarts";
import ReactEcharts from "echarts-for-react";

import { Divider, message } from "antd";

import { Link, Switch, Route } from "react-router-dom";

import { SessionStore, LocaleStore, RouterStore, PriceStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import MyIcon from "@/components/MyIcon";

interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
  price: PriceStore;
}

@inject("session", "price", "locale", "router")
@observer
class TrendContainer extends React.Component<Props, any> {
  power: any;
  constructor(props) {
    super(props);
  }

  drawPower = () => {
    let option = {
      color: ["#FFAE00", "#FF7F00", "#62B372"],
      padding: [24, 40],
      tooltip: {
        trigger: "axis",
      },
      grid: {
        height: "320px",
        left: 5,
        right: 5,
        bottom: "3%",
        containLabel: true,
      },
      // toolbox: {
      //   feature: {
      //     magicType: {
      //       type: ['line', 'bar']
      //     }
      //   }
      // },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: ["1", "2", "3", "4", "5", "6", "7"],
        splitNumber: 2,
        axisLine: {
          lineStyle: {
            color: "#E1E5FE",
          },
        },
        axisLabel: {
          margin: 30,
          textStyle: {
            color: "#000",
            fontSize: "14",
          },
        },
      },
      yAxis: {
        color: "red",
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#E1E5FE",
          },
        },
        axisLabel: {
          margin: 20,
          textStyle: {
            color: "#000",
            fontSize: "14",
          },
        },
      },
      series: [
        {
          name: "BSV",
          type: "line",
          stack: "BSV",
          smooth: true,
          data: [120, 132, 101, 134, 90, 230, 210],
          lineStyle: {
            normal: {
              width: 3,
              shadowColor: "rgba(0,0,0,0.1)",
              shadowBlur: 4,
              shadowOffsetY: 10,
            },
          },
        },
        {
          name: "BTC",
          type: "line",
          stack: "BTC",
          smooth: true,
          data: [220, 182, 191, 234, 290, 330, 310],
          lineStyle: {
            normal: {
              width: 3,
              shadowColor: "rgba(0,0,0,0.1)",
              shadowBlur: 4,
              shadowOffsetY: 10,
            },
          },
        },
        {
          name: "BCH",
          type: "line",
          stack: "BCH",
          smooth: true,
          data: [150, 232, 201, 154, 190, 330, 410],
          lineStyle: {
            normal: {
              width: 3,
              shadowColor: "rgba(0,0,0,0.1)",
              shadowBlur: 4,
              shadowOffsetY: 10,
            },
          },
        },
      ],
    };
    return option;
    // this.power.setOption(option);
  };
  render() {
    const { locale, price } = this.props;
    const {
      moneyFlag,
      bsvPrice,
      btcPrice,
      bchPrice,
      bsvCoinProfit,
      btcCoinProfit,
      bchCoinProfit,
      bsvLegacyProfit,
      btcLegacyProfit,
      bchLegacyProfit,
    } = price;
    return (
      <div className="trend">
        <div className="trend-container">
          <div className="daily-group">
            <div className="daily-box">
              <div className="daily-box-tip">{`BSV ${locale.get("login.dayEarn")}`}</div>
              <div className="icon-box icon-box-yellow">
                <MyIcon type="icon-bsv" className="icon-font" />
              </div>
              <div className="daily-box-center">
                <span className="memepool-number-font number-font-large">
                  {moneyFlag}
                  &nbsp;{bsvLegacyProfit.toFixed(2)}
                </span>
                <span className="memepool-number-font">
                  &nbsp;/&nbsp;T ≈ {bsvCoinProfit.toFixed(8)}
                </span>
                <span className="number-font-unit">{` BSV/T`}</span>
              </div>
              <div className="daily-box-bottom">
                <div>
                  <span className="memepool-number-font number-font-middle">
                    {moneyFlag}
                    &nbsp;{bsvPrice.toFixed(2)}
                  </span>
                  {` / BSV`}
                </div>
              </div>
            </div>

            <div className="daily-box">
              <div className="daily-box-tip">{`BTC ${locale.get("login.dayEarn")}`}</div>
              <div className="icon-box icon-box-orange">
                <MyIcon type="icon-btc" className="icon-font" />
              </div>
              <div className="daily-box-center">
                <span className="memepool-number-font number-font-large">
                  {moneyFlag}
                  &nbsp; {btcLegacyProfit.toFixed(2)}
                </span>
                <span className="memepool-number-font">
                  &nbsp;/&nbsp;T ≈ {btcCoinProfit.toFixed(8)}
                </span>
                <span className="number-font-unit">{` BTC/T`}</span>
              </div>
              <div className="daily-box-bottom">
                <div>
                  <span className="memepool-number-font number-font-middle">
                    {moneyFlag}
                    &nbsp;{btcPrice.toFixed(2)}
                  </span>
                  {` / BTC`}
                </div>
              </div>
            </div>

            <div className="daily-box">
              <div className="daily-box-tip">{`BCH ${locale.get("login.dayEarn")}`}</div>
              <div className="icon-box icon-box-green">
                <MyIcon type="icon-bch" className="icon-font" />
              </div>
              <div className="daily-box-center">
                <span className="memepool-number-font number-font-large">
                  {moneyFlag}
                  &nbsp;{bchLegacyProfit.toFixed(2)}
                </span>
                <span className="memepool-number-font">
                  &nbsp;/&nbsp;T ≈ {bchCoinProfit.toFixed(8)}
                </span>
                <span className="number-font-unit">{` BCH/T`}</span>
              </div>
              <div className="daily-box-bottom">
                <div>
                  <span className="memepool-number-font number-font-middle">
                    {moneyFlag}
                    &nbsp;{bchPrice.toFixed(2)}
                  </span>
                  {` / BCH`}
                </div>
              </div>
            </div>
          </div>
          {/*<div className="daily-charts">
             <div className="daily-charts-title">{locale.get("login.dailyEarn")}</div>
            <div className="daily-charts-tips">
              <div className="daily-charts-tips-left">{locale.get("login.totalPower")}</div>
              <div className="daily-charts-tips-right">{locale.get("login.okex")}</div>
            </div>
            <div className="charts-yName">{locale.get("power")}PH/S</div>
            <ReactEcharts
              className="charts"
              option={this.drawPower()}
              notMerge={true}
              lazyUpdate={true}
            /> 
          </div>*/}
        </div>
      </div>
    );
  }
}

export default TrendContainer as React.ComponentType;
